const known=s=>String(s||'MISSING').toUpperCase();

export function deriveDogEvidence(bundle={}){
 const quality=bundle?.companyQualityEvidence||{};
 const moat=bundle?.moatEvidence||{};
 const signals=quality?.signals||{};
 const trend=known(quality?.trend?.state);
 const states=Object.values(signals).map(x=>known(x?.state));
 const observed=states.filter(x=>x!=='MISSING').length;
 const supportive=states.filter(x=>x==='SUPPORTIVE').length;
 const caution=states.filter(x=>x==='CAUTION').length;
 const mixed=states.filter(x=>x==='MIXED').length;

 let durability='MISSING';
 if(moat?.state==='EVIDENCE_STACKED')durability='DIRECT_DURABILITY_SUPPORT';
 else if(moat?.state==='ECONOMIC_SUPPORT_ONLY')durability='ECONOMIC_SUPPORT_ONLY';
 else if(moat?.state==='MIXED_EVIDENCE')durability='MIXED_DURABILITY_EVIDENCE';

 let state='MISSING';
 if(observed>=3){
  if(caution>=2)state='QUALITY_RISK';
  else if(supportive>=4&&durability==='DIRECT_DURABILITY_SUPPORT'&&trend!=='DETERIORATING')state='STRONG_QUALITY_EVIDENCE';
  else if(supportive>=3&&caution===0&&trend!=='DETERIORATING')state='SUPPORTIVE_QUALITY_EVIDENCE';
  else state='MIXED_QUALITY_EVIDENCE';
 }

 return{
  status:state==='MISSING'?'MISSING':'EVIDENCE',
  state,
  observedSignals:observed,
  supportiveSignals:supportive,
  cautionSignals:caution,
  mixedSignals:mixed,
  durability,
  trend,
  trendObserved:quality?.trend?.observed??0,
  trendImproving:quality?.trend?.improving??0,
  trendDeteriorating:quality?.trend?.deteriorating??0,
  fiscalEnd:quality?.fiscalEnd||null,
  filedAt:quality?.filedAt||null,
  note:'Dog summarizes transparent Company Quality evidence. Strong quality requires broad supportive financial evidence plus direct durability support; a deteriorating prior-year trend can block STRONG/SUPPORTIVE but cannot create QUALITY_RISK by itself. It is not a trade signal, universal score or capital permission.'
 };
}
